import format from 'date-fns/format';
import { useCallback } from 'react';
import uuid from 'react-uuid';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
import { convertDate } from 'src/utils/transformation';

export interface PoHistoryResponseObject {
  action: string;
  transactionNotes: string | null;
  actionDate: string;
  document: string;
  actionDateFormatted: string;
  invoiceId: number;
  poId: string;
  receiptId: number;
  varianceId: number;
}

export type PoHistoryResponse = PoHistoryResponseObject[];

export interface PoHistoryObject extends Omit<PoHistoryResponseObject, 'actionDate'> {
  actionDate: Date;
  rowId: string;
}

export type PoHistory = PoHistoryObject[];

const usePoHistoryApi = (poId: string, immediate: boolean = true) => {
  const call = useCallback(
    () =>
      new Promise<PoHistory>((resolve, reject) => {
        axiosInstance
          .get<PoHistoryResponse>(`/po/${poId}/history`)
          .then((value) => {
            resolve(
              value?.data.map((item) => ({
                ...item,
                actionDate: convertDate(item.actionDate),
                actionDateFormatted: item.actionDate
                  ? format(new Date(item.actionDate), 'MM/dd/yyyy')
                  : '',
                rowId: uuid(),
                poId,
              })) || []
            );
          })
          .catch((error) => {
            reject(error);
          });
      }),
    [poId]
  );
  const { isLoading, value, execute } = useAsync(call, immediate);

  return { isLoading, poHistory: value, getPoHistory: execute };
};

export default usePoHistoryApi;
